<template>
        <div class="root" v-observe-visibility="{
                callback: isVisible,
                once: true
                }">

                <h1 v-if="loaded">{{title}}</h1>
                <div class="chart-container">
                        <div class="chart-message-container" v-if="getAppMode ==='custom-values'">

                                <div v-if="!isLoading">
                                        Die Werte haben sich geändert. Für die Anzeige ist eine Berechnung nötig
                                </div>

                                <div v-if="isLoading">
                                    <Loader message="Bitte warten. Die Anzeige wird vorbereitet."/>
                                </div>
                        </div>
                        <bar-chart
                                v-if="loaded"
                                :chartdata="chartdata"
                                :options="chartoptions"
                                ref="chart"
                        ></bar-chart>
                </div>

                <div v-if="!loaded">
                        <Loader message="Bitte warten. Die Berechnung wird vorbereitet"/>
                </div>
                <div>

                </div>
                <div class="alert alert-info"  v-if="hinweise != ''" v-html="hinweise"></div>
                <div class="alert alert-info" v-if="serverMessage">
                        <ul>
                                <li v-for="(message, idx) in serverMessage" v-bind:key="idx">{{message.Value}}</li>
                        </ul>
                </div>
                <div class="form-container" v-if="loaded">

                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                <label class="btn btn-secondary" v-bind:class="{ 'active': (getMode === 'single') }" @click="setMode('single')">
                                        <input type="radio" name="options" id="option2" autocomplete="off" v-bind:checked="getMode === 'single'">
                                        <span class="d-none d-sm-block">Einmalige Einzahlung</span>
                                        <span class="d-sm-none">Einmalzahlung</span>
                                </label>
                                <label class="btn btn-secondary" v-bind:class="{ active: (getMode === 'rate') }" @click="setMode('rate')">
                                        <input type="radio" name="options" id="option3" autocomplete="off"  v-bind:checked="getMode === 'rate'">
                                        <span class="d-none d-sm-block">Monatliche Einzahlung</span>
                                        <span class="d-sm-none">Monatlich</span>
                                </label>
                        </div>

                        <div class="form-row calculate-row-container">
                                <div class="form-group mb-2">
                                        <label>Betrag</label>
                                        <input type="text" class="form-control"
                                                aria-describedby="amountHelp"
                                                v-model.lazy ="amount"
                                                v-on:change="setCustomValueMode">
                                        <small id="amountHelp" v-if="error.amount" class="form-text text-danger-custom" >Bitte geben Sie einen gewünschten Betrag ein</small>
                                </div>
                                <div class="form-group mx-sm-3 mb-2">
                                        <label>Ab Datum</label>
                                        <input type="date" class="form-control"
                                                aria-describedby="dateHelp"
                                                v-model.lacy="date"
                                                @blur="validateDate"
                                                min="2016-01-01"
                                                v-on:change="setCustomValueMode" />
                                        <small id="dateHelp" v-if="error.amount" class="form-text text-danger-custom">Ab wann soll die Berechnung erfolgen</small>
                                </div>
                                <div class="form-group compare-control">
                                        <label>Vergleichszins</label>
                                        <input type="text" class="form-control"
                                                aria-describedby="dateHelp"
                                                v-model.lazy = "interest"
                                                v-on:focus="showExamples = true"
                                                v-on:change="setCustomValueMode"
                                                v-on:blur="showExamples = false; setCustomValueMode">

                                        <span class="triangle" v-on:click.prevent = "showExamples = !showExamples"></span>
                                        <small id="quoteHelp" v-if="error.amount" class="form-text text-danger-custom">Ab wann soll die Berechnung erfolgen</small>
                                        <div class="quote_examples" v-if="showExamples">
                                                <p>{{examples.title}}</p>
                                                <ul>
                                                        <li v-for="(row,idx) in examples.rows" v-if="idx !== 0">
                                                                <span>{{row[0]}}</span>
                                                                <span>{{row[1]}} %</span>
                                                                <a href="#"
                                                                        v-on:click.prevent="interest = row[1];
                                                                        setCustomValueMode();
                                                                        showExamples = false">
                                                                        übernehmen</a>
                                                        </li>
                                                </ul>
                                        </div>
                                </div>
                                <div class="form-group">
                                        <label>&nbsp;</label>
                                        <button class="btn btn-primary mb-2 " v-on:click.prevent="executeCalculation">Berechnen</button>
                                </div>
                        </div>

                        <span class="reset-values" v-on:click="resetValues">Anfangswerte laden</span>

                </div>
                <p v-if="loaded" class="intro" v-html="intro"></p>
                <p v-if="loaded" class="intro" ><small v-html="explanation"></small></p>
        </div>

</template>

<script>
    import { DateTime } from "luxon";
    import { mapGetters } from 'vuex'

    import {getToken,getCalculationFromBuffer, Tarifierung, Kontensicht} from "../service";
    import {calculateInterest, calculateTodayPos} from "./calculationData";
    import BarChart from '../components/BarChart';

    import {Tooltip} from "./tooltip";

    import Loader from '../components/Loader';

    export default {
        name: 'CalculationMod',
        components: {
                BarChart,
                Loader
        },
        data()  {
            return {
                    loaded: false,
                    isLoading: false,
                    error: {
                        amount: false,
                        date: false
                    },
                    hinweise:"",
                    chartoptions: {
                            legend: {
                                    display: true
                            },
                            maintainAspectRatio: false,
                            scaleBeginAtZero: false,
                            hover: {
                                    animationDuration: 0
                            },
                            animation: {
                                    "duration": 1000,
                                    "onComplete": function () {
                                            let chartInstance = this.chart,
                                                    ctx = chartInstance.ctx;

                                            ctx.font = Chart.helpers.fontString('14', Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);

                                            ctx.textAlign = 'center';
                                            ctx.textBaseline = 'bottom';

                                            var visibilitySwitch  = 0;

                                            this.data.datasets.forEach(function (dataset, i) {
                                                    var meta = chartInstance.controller.getDatasetMeta(i);
                                                    meta.data.forEach(function (bar, index) {
                                                            if (i % 2 ) {
                                                                    var data = dataset.data[index].toLocaleString('de-DE') + " €";
                                                                    ctx.fillText(data, bar._model.x, bar._model.y - 5);
                                                            }
                                                            visibilitySwitch++;

                                                    });
                                            });

                                            // Zeichne die heutige Position ein

                                            let scale = this.chart.scales['x-axis-0'];
                                            let customTickPos = calculateTodayPos(scale);


                                            ctx.fillStyle = "#F59B69";
                                            ctx.beginPath();
                                            ctx.arc(customTickPos, scale.top, 7, 0, 2 * Math.PI);
                                            // write TODAY
                                            ctx.textAlign = 'center';
                                            ctx.fillText("Heute", customTickPos, scale.top - 10);
                                            ctx.fill();
                                    }
                            },
                            scales: {
                                    xAxes: [{
                                            gridLines: {
                                                    drawBorder:true,
                                                    drawOnChartArea: false,
                                                    drawTicks: false,
                                                    lineWidth: 2,
                                                    color: '#505050',
                                                    z:1
                                            },
                                            ticks: {
                                                    // Include a dollar sign in the ticks
                                                    fontSize: '16',
                                                    padding: 10,

                                                    callback: function(value) {
                                                            const label = value;
                                                            return label;
                                                    },

                                            }

                                    }],
                                    yAxes: [{
                                            gridLines: {
                                                    drawBorder: false,
                                                    display:false,
                                                    drawOnChartArea: false
                                            },
                                            ticks: {
                                                display: false,
                                                min: 0
                                            }
                                    }]

                            },
                            tooltips: {
                                enabled: false,
                                backgroundColor: '#F59B69',
                                titleFontColor: 'white',
                                bodyFontColor: 'white',
                                cornerRadius: 0,
                                callbacks: {
                                        label: function(tooltipItem, data) {

                                                let label = tooltipItem.value || '';
                                                return label.toLocaleString('de-DE') + " €";
                                        }
                                    },
                                    enabled: false,

                                    custom: (toolTipModel) => {
                                            Tooltip(toolTipModel, this.$refs.chart.$data._chart);
                                    }
                            }
                    },
                    editing: false,
                    showExamples: false
                }
        },
        watch: {
                chartdata: function() {
                        if (this.$refs.chart ) {
                                this.$refs.chart.renderChart(this.chartdata, this.chartoptions)
                        }
                },
                getAppMode: function() {
                        if (this.$refs.chart ) {
                                this.$refs.chart.renderChart(this.chartdata, this.chartoptions)
                        }
                }
        },
        filters: {
                aLocaleString: function(value) {
                        if (value) {
                                return value.toLocaleString('de-DE');
                        }
                        return value
                }
        },
        computed: {
                ...mapGetters({
                        getCalculationDOB: 'getCalculationDOB' ,
                        getMode: 'getMode',
                        getAppMode: 'getAppMode'
                }),
                title() {
                        return this.$store.state.buffer.settings.title;
                },
                intro() {
                        return this.$store.state.buffer.settings.intro;
                },
                explanation() {
                        return this.$store.state.buffer.settings.explanation;
                },
                examples() {
                        return this.$store.state.buffer.settings.examples;
                },
                serverMessage() {
                        return this.$store.getters['servermessage'];
                },
                amount: {
                        get() {
                             return this.$store.getters['getAmount'].toString().replace( /\./g, "," );
                        },
                        set(amount) {
                              this.editing = true;
                              this.$store.dispatch("setAmount", amount.replace( /\,/g, "." ))
                        }
                },
                date: {
                        get() {
                                const date = this.$store.getters["getCalculationDate"];

                                return (date) ? DateTime.fromISO(date).toFormat("yyyy-LL-dd") : null;
                        },
                        set(date) {
                                this.$store.dispatch("setDate", date);
                                this.editing = true;
                        }
                },
                interest: {
                       get() {
                               return this.$store.getters['interestRate'].toString().replace( /\./g, "," );
                       },
                       set(interest) {
                               this.editing = true;
                               this.$store.dispatch("setInterest",(interest).replace( /\,/g, "." ));
                       }
                },

                dateOfPension: {
                        get() {
                                return DateTime.fromISO(this.$store.getters["dateOfPension"]);
                        }
                },

                chartdata()  {
                        if (!this.loaded || this.editing) return {};

                        const idxAxis = this.$store.getters['getXAxisIndex'];
                        const rows =  this.$store.getters['getDataRows'];
                        const dateOfPension = this.dateOfPension;

                        const axisSeries = [], valueSeries = [];
                        const isoDates = [];
                        const idxValue = this.$store.getters['getValueIndex'];

                        for (let i = 0, j = rows.length; i < j ;i++) {
                                let vertragsmonat = DateTime.fromISO(rows[i][idxAxis]);
                                let nextVertragsmonat = DateTime.fromISO(rows[i + 1][idxAxis]);

                                if(rows[i][idxValue] > 0 ) {
                                        axisSeries.push(vertragsmonat.toFormat('dd.LL.yyyy'));
                                        valueSeries.push(rows[i][idxValue]);
                                        isoDates.push(vertragsmonat);
                                }

                                if ( nextVertragsmonat > dateOfPension) {
                                        break;
                                }
                        }

                        return {
                                labels: axisSeries,
                                datasets: [

                                        {
                                                type: 'bar',
                                                label: 'Vergleichsanlage',
                                                data: calculateInterest(isoDates),
                                                backgroundColor: '#E0E0E0',

                                        },
                                        {
                                                type: 'bar',
                                                label: 'IDEAL UniversalLife',
                                                backgroundColor: '#0082C8',
                                                data: valueSeries,
                                        }

                                ]
                        }
                },
        },
        methods: {
                setCustomValueMode() {
                     this.editing = false;
                     this.$store.dispatch("setAppMode", "custom-values")
                },

                validateDate(e) {
                        // Datum größer 01.01.2016
                        const minimalDate = DateTime.fromISO('2016-01-01');
                        // Datum ist der 01 des Monats

                        let inputDate =  DateTime.fromISO(e.target.value);

                        if (inputDate.invalid) {
                                return true;
                        }

                        if (inputDate < minimalDate) {
                                inputDate = minimalDate;
                                this.hinweise = "<span>Das Mindestdatum ist der 01.01.2016 und daher wid Ihre Eingabe angepasst</span>";
                        }

                        if (inputDate.day !== 1) {
                                let  firstOfMonth = inputDate.set({day: 1})
                                this.hinweise = "<span>Die Berechnung ist nur für den ersten des gewünschten Monats möglich. Das Datum wurde daher angepasst</span>";
                                this.$store.dispatch("setDate", firstOfMonth.toFormat("yyyy-LL-dd"))

                        } else {
                                this.$store.dispatch("setDate", inputDate.toFormat("yyyy-LL-dd"))

                        }

                        this.$store.dispatch("setAppMode", "custom-values")
                },
                async resetValues() {
                        this.$store.dispatch("setAppMode", "buffer");
                        this.$store.dispatch("deleteCustomCalculation")
                },
                async isVisible(isVisible, entry) {

                        if (isVisible) {

                                const cachedCalculation = await getCalculationFromBuffer();
                                await this.$store.dispatch("addBufferData", cachedCalculation.data);

                                this.loaded = true;
                        }
                },
                async setMode(mode) {
                      await this.$store.dispatch("setMode", mode);

                },
                async executeCalculation() {

                        this.isLoading = true;
                        this.$store.dispatch("setAppMode", "custom-values")
                        // Aktualisiere die Berechnungsvorgaben
                        // Führe eine Berechnung durch
                        // Lade einen anonymen Token und persistiere diesen
                        const token = await getToken();
                        await this.$store.dispatch("addAuthToken", token.data);
                        const calculationResponse = await Tarifierung(this.$store.state.calculation);
                        await this.$store.dispatch("addTarifierungsResult", calculationResponse.data);
                        const kontensichtResponse = await Kontensicht();
                        await this.$store.dispatch("addCustomCalculation", kontensichtResponse.data);
                        this.$store.dispatch("setAppMode", "custom-calculation");
                        this.isLoading = false;
                }
        },

    }
</script>

<style lang="scss" scoped>
        h1 {
                text-align:center;
                margin-bottom:4vh;
        }
        .intro {
                margin-bottom:3vh;
                margin-top:3vh;
        }
        .btn-group {
                border: 2px solid #0082c8;
                border-radius: 5px;
        }
        .chart-container {
                position:relative;
                z-index:10;
                margin-bottom:2vh;
                overflow: auto;
                > div{
                        min-width: 500px;
                }
        }
        .chart-message-container {
                background:rgba(84,191,207,.8);
                width:100%;
                height:100%;
                position: absolute;
                backdrop-filter: blur(2px);
                display: flex;
                justify-content: center;
                align-content: center;
                align-items:center;
                flex-direction: column;
                padding:1em;
                > div  {
                        font-size:24px;
                }

                @media (min-width: 576px) {}
                @media (min-width: 768px) {
                        padding:initial;
                }
                @media (min-width: 992px) { }
                @media (min-width: 1200px) { }
        }
        .form-container {
                label, p {
                        color:#000
                }
                margin: 1em;

                .form-group {
                        width: 100%;
                        &:last-child {
                                label {
                                        display:none;
                                }
                                button {
                                        margin-left:0
                                }
                        }
                }

                @media (min-width: 576px) {}
                @media (min-width: 768px) {
                        margin: 3em 10%;
                        .form-group {
                                width: initial;
                                &:last-child {
                                        label {
                                                display:block;
                                        }
                                        button {
                                                margin-left:initial
                                        }
                                }
                        }
                        .intro {
                                margin:auto
                        }
                }
                @media (min-width: 992px) { }
                @media (min-width: 1200px) { }
        }
        .intro {
                margin:1em;
                @media (min-width: 768px) {
                        margin: auto


                }
        }
        .calculate-row-container {
                display: flex;
                justify-content: flex-start;
                margin-left:0;
                .btn {
                        margin-left: 8px;
                }
        }
        section{
                display:flex;
                flex-direction:row;

        }

        .btn-group-toggle {
                border:none;
                border-bottom: 1px solid #ccc;
                width: 100%;
                border-radius:0;

                label.btn.btn-secondary {
                        border: none;
                        box-shadow:none;
                }

                label.btn.btn-secondary.active {

                        background: transparent;
                        color: #0082C8;
                        border-bottom: 2px solid #0082C8;
                        border-radius: 0;
                        outline: none;
                }
                label.btn.btn-secondary {
                        background:transparent;
                        border-color:#fff;
                        color:#adadad;
                        outline: none;
                }


                @media (min-width: 576px) {

                        padding:32px
                }
        }

        .reset-values {
                text-decoration: underline;
                cursor:pointer;
        }

        .compare-control {
                position:relative;

                .triangle {
                        display: inline-block;
                        width: 0;
                        height: 0;
                        border-left: 10px solid transparent;
                        border-right: 10px solid transparent;
                        border-top: 15px solid #0082c8;
                        position: absolute;
                        right: 10px;
                        top: 44px;
                        z-index: 1;
                        cursor: pointer;
                }
        }
        .quote_examples {

                background-color:#0082C8;
                padding:1em;
                z-index: 0;

                p, li, a {
                        color:#fff;
                        font-size:14px;
                }

                li  {
                        margin-bottom: 0.5em;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        span {
                                display: inline-block;
                                margin-right:3em;

                                &:last-child {
                                        margin-right:0em
                                }
                        }
                }



                @media (min-width: 576px) {}
                @media (min-width: 768px) {
                        position: absolute;
                        top:70px;
                        right:0;

                        li span {
                                white-space: nowrap;
                        }
                }
                @media (min-width: 992px) { }
                @media (min-width: 1200px) { }
        }

</style>


